import { lazy, Suspense } from "react";

import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/transcript/main"));

const Transcript = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default Transcript;